import { Suspense } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
function DefaultLoadingComponent() {
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    minHeight: 200,
    justifyContent: "center"
  });
}
export function SuspenseLoadingState({
  children,
  loadingComponent: LoadingComponent = DefaultLoadingComponent,
  errorComponent
}) {
  const errorFallback = errorComponent ? error => {
    const ErrorComponent = errorComponent;
    return /*#__PURE__*/_jsx(ErrorComponent, {
      error: error
    });
  } : undefined;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: errorFallback,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(LoadingComponent, {}),
      children: children
    })
  });
}